<template>
  <div>
    <v-row>
      <v-col class="pa-0 mx-0" cols="12" sm="6">
        <v-stepper alt-labels class="elevation-0" :value="1">
          <v-stepper-header>
            <v-stepper-step step="1">
              Select Date
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2">
              Your Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="✔">
              Confirmation
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" sm="6" class="pt-0">
        <h1>Book your trial day at {{ property.name }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-1" v-for="(pet, index) in pets" :key="pet.index">
        <v-row>
          <v-col cols="12" sm="3" style="margin-bottom: -30px">
            <span class="subheading">Who will be joining us?</span>
            <v-text-field
                class="pt-2"
                v-model="pet.name"
                placeholder="Pet name"
                outlined
            />
          </v-col>
          <v-col cols="12" sm="3" style="margin-bottom: -30px">
            <span class="subheading">What is your pet's gender?</span>
            <select-input
                outlined
                class="pt-2"
                item-value="value"
                item-text="text"
                v-model="pet.sex"
                :items="sex"
                label="Pet sex"
            />
          </v-col>
          <v-col cols="12">
          <p style="cursor: pointer; text-decoration: underline;" v-if="index!==0" @click="removePet(index)">
              Remove pet
          </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center" sm="6">
        <a @click="addPet()">
          <span class="mr-2">Add another pet +</span>
        </a>
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col cols="12" sm="6">
        <span class="subheading text-left">What date would you like to attend?</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" class="py-0" align="center">
        <v-date-picker outlined
                       v-model="date"
                       width="100%"
                       style="max-width: 350px"
                       no-title
                       :allowed-dates="getAllowedDates"
        ></v-date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn color="success" block
               :disabled="!canSubmit"
               @click="$router.push({name: 'OnboardingStep2', params: {propertySlug: $route.params.propertySlug}})"
        >
          Next
        </v-btn>
      </v-col>
    </v-row>
    <img v-if="property.facebook_tracking_pixel !== null" :src="`https://www.facebook.com/tr?id=${property.facebook_tracking_pixel}&ev=PageView`" height="1" width="1" style="display:none"/>
  </div>
</template>

<script>
import store from "@/store";
import {mapGetters} from "vuex";
import SelectInput from "@/components/SelectInputComponent";

export default {
  name: 'BookTrialDaySelectDate',
  title: 'Book a trial day | Select date',
  props: ['source'],
  components: {
    SelectInput
  },
  async beforeRouteEnter(to, from, next) {
      await store.dispatch("newCustomerOnboarding/loadAvailability", to.params.propertySlug)
      next();
  },
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch("newCustomerOnboarding/loadAvailability", to.params.propertySlug)
    next();
  },
  data: () => ({
    sex: [
      {text: 'Male', value: 'M'},
      {text: 'Female', value: 'F'},
    ],
  }),
  mounted() {
    //Set the source if it has not been already set
    if(this.sourcePersisted === null && this.source !== null) {
      this.$store.commit('newCustomerOnboarding/SET_SOURCE', this.source);
    }
  },
  computed: {
    ...mapGetters({
      property: 'newCustomerOnboarding/property',
      availability: 'newCustomerOnboarding/availability',
      canSubmit: 'newCustomerOnboarding/step1IsValid',
      sourcePersisted: 'newCustomerOnboarding/source',
    }),
    canSubmit ()  {
      return this.pets.length > 0 &&
          this.pets.every(pet => pet.name && pet.name.trim() !== '' && pet.sex && pet.sex.trim() !== '') &&
          this.date !== null;
    },
    pets: {
      get() {
        return this.$store.state.newCustomerOnboarding.pets;
      },
      set(value) {
        this.$store.commit('newCustomerOnboarding/SET_PETS', value);
      }
    },
    date: {
      get () {
        return this.$store.state.newCustomerOnboarding.date;
      },
      set (value) {
        this.$store.commit('newCustomerOnboarding/SET_DATE', value);
      }
    }
  },
  methods: {
    addPet() {
      this.pets.push({
        name: '',
        sex: null,
      });
    },
    removePet(index) {
      this.pets.splice(index, 1);
    },
    getAllowedDates (val) {
      if (this.availability.indexOf(val) !== -1) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>
